import React, { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "../../Redux/authSlice";
import micIcon from "../../Asset/mic.svg";

export const DemoButton = forwardRef(function DemoButton(
  { text, view, className = "", variant = "primary" },
  ref
) {
  const isLoggedIn = useSelector(selectIsLoggedIn);

  const animClass =
    view === undefined
      ? ""
      : view
        ? " anim-preserve scale-100 transition-transform duration-[600ms] ease-out opacity-100"
        : "opacity-0 scale-50";

  const isLight = variant === "light";

  // "light" surface: pale blue fill with a subtle blue border and blue text,
  // and a blue gradient icon circle holding a white mic.
  // "primary" (default): the original blue gradient with white text and a white
  // icon circle.
  const surfaceClass = isLight
    ? "bg-[#D8EFFD] border border-[#3AB1F626] text-[#4081FE] hover:bg-[#C9E7FB]"
    : "bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] text-white";

  return (
    <div ref={ref} className={animClass}>
      <NavLink
        to={isLoggedIn ? "/app" : "/login"}
        className={`font-inter transition-all duration-300 ease-in-out leading-none lg:text-[18px] md:text-base text-sm w-max p-2 flex items-center gap-2 rounded-full font-semibold ${surfaceClass} ${className}`}
      >
        <span
          className={`${
            isLight
              ? "bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]"
              : "bg-white"
          } lg:p-2 p-1.5 rounded-full`}
        >
          <ReactSVG
            src={micIcon}
            beforeInjection={(svg) => {
              svg.setAttribute("class", "lg:w-5 w-4 lg:h-5 h-4");
              if (isLight) {
                svg
                  .querySelectorAll("path, rect, circle, polyline, line, ellipse, polygon")
                  .forEach((el) => {
                    el.setAttribute("fill", "#ffffff");
                    el.setAttribute("stroke", "#ffffff");
                  });
              }
            }}
          />
        </span>
        <span className="pl-2 pr-6">{text}</span>
      </NavLink>
    </div>
  );
});
